import { Instance } from 'mobx-state-tree';
import { ShopifyFieldMappingDtoModelBase } from './ShopifyFieldMappingDtoModel.base';

/* The TypeScript type of an instance of ShopifyFieldMappingDtoModel */
export interface ShopifyFieldMappingDtoModelType
  extends Instance<typeof ShopifyFieldMappingDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyFieldMappingDtoModel */
export {
  selectFromShopifyFieldMappingDto,
  shopifyFieldMappingDtoModelPrimitives,
  ShopifyFieldMappingDtoModelSelector,
} from './ShopifyFieldMappingDtoModel.base';

/**
 * ShopifyFieldMappingDtoModel
 */
export const ShopifyFieldMappingDtoModel = ShopifyFieldMappingDtoModelBase;
